import React, { useState } from "react"
import { Flex } from "@rebass/grid/emotion"
import { Link } from "gatsby"
import VisuallyHidden from "@reach/visually-hidden"

// Components
import { Container } from "@components/grid"
import Menu from "@layouts/menu"
import { default as MenuIcon } from "@svgs/menu"

// Hooks
import useScroll from "@hooks/useScroll"
import { useSiteMetadata } from "@hooks/useSiteMetadata"

// Images
import logo from "@images/logo-full.svg"
import titleLogo from "@images/title.svg"

// Styles
import { Toggle, Wrapper } from "./styles"

const Header = () => {
  const [open, setOpen] = useState(false)
  const position = useScroll()
  const { title } = useSiteMetadata()

  return (
    <Wrapper>
      <Container maxWidth="1200px">
        <Flex alignItems="center" justifyContent="space-between">
          <Link to="/">
            <img
              src={position.y >= 100 ? titleLogo : logo}
              alt={title}
              style={{ marginBottom: 0 }}
            />
          </Link>
          <Toggle type="button" onClick={() => setOpen(!open)}>
            <MenuIcon />
            <VisuallyHidden>Toggle Navigation</VisuallyHidden>
          </Toggle>
        </Flex>
      </Container>
      <Menu open={open} setOpen={() => setOpen(false)} />
    </Wrapper>
  )
}

export default Header
